<div class="relative flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
  <span class="font-medium text-secondary">Version {{view.version}}. Copyright &copy; {{view.year}} TravelFind.Me (Pty) Ltd. All rights reserved</span>
</div>
